var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_104_1224)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_104_1224)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 0H5.33333V0.666667H7.66667V3.34153C4.13963 3.5152 1.33333 6.42987 1.33333 10V10.6667V11.3333H14H14.6665L14.6667 10.6667V10C14.6667 6.42987 11.8604 3.5152 8.33333 3.34153V0.666667H10.6667V0ZM14 10C14 6.6863 11.3137 4 8 4C4.6863 4 2 6.6863 2 10V10.6667H13.9998L14 10ZM16 15.3333V16H0V15.3333H0.333333V15.2342L1.80813 13H14.1755L15.6639 15.2334V15.3333H16ZM14.9294 15.3333L13.8186 13.6667H2.16687L1.06669 15.3333H14.9294Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_104_1224",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 0H5.33333V0.666667H7.66667V3.34153C4.13963 3.5152 1.33333 6.42987 1.33333 10V10.6667V11.3333H14H14.6665L14.6667 10.6667V10C14.6667 6.42987 11.8604 3.5152 8.33333 3.34153V0.666667H10.6667V0ZM14 10C14 6.6863 11.3137 4 8 4C4.6863 4 2 6.6863 2 10V10.6667H13.9998L14 10ZM16 15.3333V16H0V15.3333H0.333333V15.2342L1.80813 13H14.1755L15.6639 15.2334V15.3333H16ZM14.9294 15.3333L13.8186 13.6667H2.16687L1.06669 15.3333H14.9294Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_104_1224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V16H16V0Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_1224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_104_1224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contactUs.77b75efec584a7a28a228c4ff8e08656.svg";
export { ForwardRef as ReactComponent };